// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2P1wW","label":"styles_label__svAHk"};